import m from 'mithril';
import modalCloseButton from '../../../components/modalCloseButton';

const modal = {
  key: 'USER_AUTH_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;
  },
  view({ state }) {
    return m('.modal', { id: modal.key },
      [
        m('.modal-dialog[role="document"]',
          [
            m('.modal-content',
              [
                m('.modal-header',
                  [
                    m('h1.modal-title', 'Create New User'),
                    m("div", { "class": "btn btn-icon btn-sm btn-active-light-primary ms-2", "data-bs-dismiss": "modal", "aria-label": "Close" },
                      m(modalCloseButton)
                    )
                  ]),
                m('.modal-body',
                  [
                    m('form', [
                      m('div.form-group', [
                        m('label', 'Issue ID:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.issueId = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Title:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.title = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Description:'),
                        m('textarea.form-control', {
                          oninput: (e) => state.description = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Category:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.category = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Priority:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.priority = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Status:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.status = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Opened Date:'),
                        m('input.form-control[type="date"]', {
                          oninput: (e) => state.openedDate = e.target.value,
                        }),
                      ]),
                      m("br"),
                      m('div.form-group', [
                        m('label', 'Assigned To:'),
                        m('input.form-control[type="text"]', {
                          oninput: (e) => state.assignedTo = e.target.value,
                        }),
                      ]),
                    ]),
                  ]),
                m('.modal-footer',
                  [
                    
                    m('button.btn.btn-primary[type="button"]', {
                      onclick() {
                        if (!state.driverName || !state.driverPhoneNumber) {
                          alert('Please fill in both fields');
                          return;
                        }
                        state.loading = true;
                        m.redraw();
                        // some async tings
                        setTimeout(() => {
                          // Create new driver logic goes here
                          console.log(`Created new driver: ${state.driverName} - ${state.driverPhoneNumber}`);
                          state.loading = false;
                          m.redraw();
                          modal.hide();
                        }, 2000);
                      },
                    }, 'Continue'),
                  ]),
              ]),
          ]),
      ]);
  },
};


export default modal;
